<template>
  <div>
    <small v-if="field.desc_text" v-html="field.desc_text"></small>
    <v-checkbox
      :rules="rules"
      v-model="value"
      :value="1"
      :true-value="1"
      :color="color"
      @change="change(value)"
    >
      <template v-slot:label>
        <span v-html="field.label"></span>
      </template>
    </v-checkbox>
  </div>
</template>
<script>
export default {
  name: "NinjaFormsCheckBox",
  props: ["rules", "color", "label", "field"],
  data() {
    return {
      selected: [],
      value: "false"
    };
  },
  mounted() {
    this.change("false");
  },
  methods: {
    change(v) {
      this.value = v;
      this.$emit("checkBoxChanged", {
        value: this.value,
        field: this.field
      });
    }
  }
};
</script>
